module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAABPElEQVQoU4WQzStEYRTGf2fGElGSKCGSbCwmG8uZITPD0kaWNFe2dkop/8LMsJWNJfeOZox/QLOw8JFEUiQUmSVzj+7M23wYcnbnPM/7O897BMtZBdaBPNo0R2rqmf8qnulEvvaAACobgpU+Ax0tvVOucYshtmfv/+Qs7ffi8+cQhoznUoinJxDXBmkzwzvQIMnYbQPIsgdAjoE+o72jEpNSs+iM4dcjRDqM+AC+IMnpqwrIOhwG1wP0lFPrKz4Jk4ieliFeLdsjKDmQbjN5Qd0YqZkT4gfjIE51iTziEmYrcuF5qxCvW8n0U/zMggwaUAFlDdFNkGZztxtEJ2u/Ww8pJXK6UPUSlY9dV3qOSIhE9Kl23AjxVMtuRyWLEKiYlbxJ8PYT/TvEc82nW2lhB9EQKjkKLLAb+WhMB9/RFWLrNaATqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.png
// module id = lP78
// module chunks = 0